<template>
  <div class="main">
    <top-header :type="6" placeholder="合同预览及确认" fontSize="0.32rem" />
    <swiper class="swiper swiper_top" :options="swiperOptionh" ref="mySwiper">
      <swiper-slide v-for="(item, index) in photoArr" :key="index">
        <img v-lazy="item" alt="" @click="showPic(index)">
      </swiper-slide>
    </swiper>
    <div class="tab_com">
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide :class="current === index ? 'active' : ''" v-for="(item, index) in photoArr" :key="index">
          <img v-lazy="item" alt="" @click="toSwiper(index)">
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn_con m_flex_box flex_hc">
      <van-button size="small" type="info" @click="submit">提交卖方审核</van-button>
      <van-button size="small" @click="$router.go(-1)">取消</van-button>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
      current: 0,
      swiperOptionh: {
        on: {
          slideChangeTransitionEnd: (data) =>{
            this.current = data.activeIndex;
            this.$refs.swiperThumbs.$swiper.slideTo(data.activeIndex, 100);
          },
        },
        spaceBetween: 10,
      },
      swiperOptionThumbs: {
        slidesPerView: 'auto',
        touchRatio: 0.2,
        freeMode: true,
        slideToClickedSlide: true
      },
      photoArr: []
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  mounted() {
    this.getPhotos();
    this.$nextTick(() => {
      const swiperTop = this.$refs.mySwiper.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
    })
  },
  methods: {
    showPic(index){
      ImagePreview({
      images: this.photoArr,
      startPosition: index,
    });
    },
    toSwiper(index) {
      console.log(index)
      this.$refs.mySwiper.$swiper.slideTo(index, 100);
    },
    getPhotos() {
      return new Promise((resolve) => {
        this.$http.post('cms/contractData/reg/getContractDataOnlineShow.do', qs.stringify({
            contractId: this.$route.query.id
          })).then(res => {
          if(res.success){
            this.photoArr = res.obj;
            resolve(res)
          } else {
            this.$dialog.alert({
              title: '提示',
              message:res.msg,
            });
          }
        })
      });
    },
    submit() {
      this.$http.post('cms/contractData/reg/doSendOnlineContract.do', qs.stringify({
        contractId: this.$route.query.id
      })).then(res => {
        this.$toast('已提交卖方审核，请耐心等待');
        setTimeout(() => {
          this.$router.push({
            path: '/myHouseDeal'
          });
        }, 1000);
      })
    },
  },
};
</script>
<style lang="less" scoped>
.btn_con{
  position: absolute;
  z-index: 9;
  bottom: 1.42rem;
  left: 0;
  right: 0;
  .van-button{
    width: 2.2rem;
    margin: 0 0.4rem;
  }
}
.main{
  height: 100vh;
  background-color: #161616;
}
.swiper_top{
  img{
    width: 6.9rem;
    height: 9.87rem;
    display: block;
    margin: 0.3rem auto;
  }
}
.tab_com{
  position: absolute;
  bottom: 0rem;
  left: 0;
  right: 0;
  z-index: 9;
  /deep/
  .swiper-slide {
    width: 0.8rem;
    padding: 0 0.1rem;
    opacity: 0.5;
    &.active{
      opacity: 1;
    }
    img{
      width: 0.8rem;
      height: 1.12rem;
    }
  }
}
</style>